import React, { useState, useEffect, useRef, useContext } from "react";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";
import {
  Button,
  Card,
  CardContent,
  Container,
  Typography,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";

const WORD_POOL = [
  "kot",
  "drzewo",
  "książka",
  "okno",
  "samochód",
  "rzeka",
  "lampa",
  "telefon",
  "biurko",
  "zegarek",
  "klucz",
  "kubek",
  "morze",
  "chmura",
  "ptak",
  "droga",
  "komputer",
  "szkoła",
  "rower",
  "but",
  "dom",
  "kwiat",
  "traktor",
  "piłka",
  "pies",
  "stół",
  "krzesło",
  "łóżko",
  "szafa",
  "obraz",
  "lustro",
  "drzwi",
  "podłoga",
  "sufit",
  "ściana",
  "okulary",
  "portfel",
  "torba",
  "plecak",
  "zeszyt",
  "długopis",
  "ołówek",
  "nożyczki",
  "papier",
  "gazeta",
  "talerz",
  "widelec",
  "łyżka",
  "nóż",
  "patelnia",
  "garnek",
  "szklanka",
  "butelka",
  "lodówka",
  "pralka",
  "piekarnik",
  "czajnik",
  "ręcznik",
  "mydło",
  "szampon",
  "szczoteczka",
  "grzebień",
  "poduszka",
  "kołdra",
  "koc",
  "dywan",
  "zasłona",
  "zegar",
  "kalendarz",
  "półka",
  "biżuteria",
  "pierścionek",
  "pasek",
  "czapka",
  "szalik",
  "rękawiczki",
  "kurtka",
  "płaszcz",
  "spodnie",
  "koszula",
  "sukienka",
  "spódnica",
  "skarpetka",
  "trampek",
  "parasol",
  "walizka",
  "samolot",
  "pociąg",
  "autobus",
  "tramwaj",
  "statki",
  "helikopter",
  "motocykl",
  "hulajnoga",
  "most",
  "ulica",
  "chodnik",
  "park",
  "las",
  "ogród",
  "góra",
  "jezioro",
  "plaża",
  "pustynia",
  "wyspa",
  "wulkan",
  "księżyc",
  "słońce",
  "gwiazda",
  "niebo",
  "deszcz",
  "śnieg",
  "wiatr",
  "burza",
  "piorun",
  "tęcza",
  "ogień",
  "woda",
  "ziemia",
  "kamień",
  "piasek",
  "drzewce",
  "liść",
  "gałąź",
  "trawa",
  "grzyb",
  "owoc",
  "warzywo",
  "jabłko",
  "banan",
  "cytryna",
  "truskawka",
  "chleb",
  "bułka",
  "ser",
  "mleko",
  "jajko",
  "cukier",
  "sól",
  "kawa",
  "herbata",
  "sok",
  "ryba",
  "koń",
  "krowa",
  "owca",
  "świnia",
  "kura",
  "kaczka",
  "piesek",
  "mysz",
  "królik",
  "wilk",
  "lis",
  "niedźwiedź",
  "słoń",
  "żyrafa",
  "lew",
  "tygrys",
  "małpa",
  "delfin",
  "rekin",
  "orzeł",
  "sowa",
  "bocian",
  "motyl",
  "pszczoła",
  "mrówka",
  "pajak",
  "muszla",
  "kamionka",
  "muzeum",
  "teatr",
  "kino",
  "szpital",
  "sklep",
  "apteka",
  "restauracja",
  "hotel",
  "lotnisko",
  "stacja",
  "zamek",
  "wieża",
  "ratusz",
  "kościół",
  "mostek",
  "fontanna",
  "ławeczka",
  "latarnia",
  "pomnik",
  "bramka",
  "boisko",
  "siatka",
  "rakieta",
  "basen",
  "łyżwy",
  "narty",
  "sanki",
  "flaga",
  "mapa",
  "kompas",
  "pędzel",
];

export default function WordMemoryRSVP() {
  const [gameState, setGameState] = useState("START"); // START, DISPLAYING, INPUT, RESULTS
  const [wordCount, setWordCount] = useState(8); // Liczba słów do zapamiętania
  const [wpm, setWpm] = useState(300); // Szybkość: słowa na minutę (Words Per Minute)
  const [targetWords, setTargetWords] = useState([]);
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [userWordsInput, setUserWordsInput] = useState("");
  const { userData } = useContext(UserDataContext);
  const [results, setResults] = useState({
    correct: [],
    incorrect: [],
    missed: [],
  });

  const timerRef = useRef(null);

  // Obliczanie czasu wyświetlania jednego słowa w milisekundach
  const wordDuration = (60 / wpm) * 1000;

  const startTest = () => {
    // Losowanie unikalnych słów z puli
    const shuffled = [...WORD_POOL].sort(() => 0.5 - Math.random());
    const selected = shuffled.slice(0, wordCount);

    setTargetWords(selected);
    setCurrentWordIndex(0);
    setUserWordsInput("");
    setGameState("DISPLAYING");
  };

  // Efekt sterujący wyświetlaniem słów jedno po drugim
  useEffect(() => {
    if (gameState !== "DISPLAYING") return;

    if (currentWordIndex < targetWords.length) {
      timerRef.current = setTimeout(() => {
        setCurrentWordIndex((prev) => prev + 1);
      }, wordDuration);
    } else {
      setGameState("INPUT");
    }

    return () => clearTimeout(timerRef.current);
  }, [gameState, currentWordIndex, targetWords, wordDuration]);

  const checkAnswers = (e) => {
    e.preventDefault();

    // Formatowanie wpisanych słów (małe litery, usunięcie spacji, podział po przecinku lub spacji)
    const cleanInput = userWordsInput
      .toLowerCase()
      .replace(/,/g, " ")
      .split(/\s+/)
      .filter((w) => w.trim() !== "");

    const correct = [];
    const incorrect = [];

    cleanInput.forEach((word) => {
      if (targetWords.includes(word)) {
        if (!correct.includes(word)) correct.push(word);
      } else {
        incorrect.push(word);
      }
    });

    const missed = targetWords.filter((word) => !correct.includes(word));

    setResults({ correct, incorrect, missed });
    setGameState("RESULTS");
  };

  return (
    <div>
      <VN userData={userData} />
      <Container sx={{ py: 5 }}>
        <Card
          elevation={1}
          sx={{
            backgroundColor: "#F8FAFC",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#FFFFFF",
              textAlign: "center",
              pt: 4,
              pb: 2,
              px: 3,
            }}
          >
            <h1 style={{ color: "#333" }}>Pamięć & Szybkie Czytanie</h1>

            {gameState === "START" && (
              <div>
                <p
                  style={{ fontSize: "16px", color: "#666", lineHeight: "1.6" }}
                >
                  Słowa będą pojawiać się na środku ekranu jedno po drugim w
                  bardzo szybkim tempie. Skoncentruj wzrok w jednym punkcie i
                  postaraj się zapamiętać jak najwięcej z nich!
                </p>
                <div
                  style={{
                    margin: "30px 0",
                    background: "#f9f9f9",
                    padding: "20px",
                    borderRadius: "8px",
                  }}
                >
                  <div style={{ marginBottom: "15px" }}>
                    <label style={{ marginRight: "10px", fontWeight: "bold" }}>
                      Liczba słów:
                    </label>
                    <select
                      value={wordCount}
                      onChange={(e) => setWordCount(Number(e.target.value))}
                      style={selectStyle}
                    >
                      {[5, 8, 10, 12, 15].map((n) => (
                        <option key={n} value={n}>
                          {n} słów
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label style={{ marginRight: "10px", fontWeight: "bold" }}>
                      Prędkość (WPM):
                    </label>
                    <select
                      value={wpm}
                      onChange={(e) => setWpm(Number(e.target.value))}
                      style={selectStyle}
                    >
                      {[200, 250, 300, 350, 400].map((speed) => (
                        <option key={speed} value={speed}>
                          {speed} słów/min
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <Button onClick={startTest} size="large">
                  Rozpocznij test
                </Button>
              </div>
            )}

            {gameState === "DISPLAYING" && (
              <div>
                <p style={{ color: "#888" }}>
                  Słowo {currentWordIndex + 1} z {targetWords.length}
                </p>
                <div
                  style={{
                    fontSize: "48px",
                    fontWeight: "bold",
                    color: "#ff4d4f",
                    margin: "60px 0",
                    minHeight: "70px",
                    letterSpacing: "1px",
                  }}
                >
                  {targetWords[currentWordIndex]}
                </div>
                <div
                  style={{
                    width: "100%",
                    backgroundColor: "#eee",
                    height: "6px",
                    borderRadius: "3px",
                  }}
                >
                  <div
                    style={{
                      width: `${((currentWordIndex + 1) / targetWords.length) * 100}%`,
                      backgroundColor: "#ff4d4f",
                      height: "100%",
                      borderRadius: "3px",
                      transition: `width ${wordDuration}ms linear`,
                    }}
                  />
                </div>
              </div>
            )}

            {gameState === "INPUT" && (
              <form onSubmit={checkAnswers}>
                <h2>Czas na Twoją odpowiedź!</h2>
                <p style={{ color: "#666" }}>
                  Wpisz wszystkie zapamiętane słowa (oddzielaj je spacją lub
                  przecinkiem):
                </p>
                <textarea
                  autoFocus
                  value={userWordsInput}
                  onChange={(e) => setUserWordsInput(e.target.value)}
                  placeholder="np. kot pies drzewo okno"
                  style={{
                    width: "100%",
                    height: "120px",
                    fontSize: "18px",
                    padding: "10px",
                    boxSizing: "border-box",
                    borderRadius: "6px",
                    border: "2px solid #ccc",
                    marginBottom: "20px",
                    resize: "none",
                  }}
                />
                <Button type="submit" size="large">
                  Sprawdź wyniki
                </Button>
              </form>
            )}

            {gameState === "RESULTS" && (
              <div>
                <h2>Podsumowanie testu</h2>
                <p style={{ fontSize: "22px" }}>
                  Twój wynik:{" "}
                  <strong style={{ color: "#52c41a" }}>
                    {results.correct.length}
                  </strong>{" "}
                  / {targetWords.length}
                </p>

                <div
                  style={{
                    textAlign: "left",
                    background: "#f5f5f5",
                    padding: "20px",
                    borderRadius: "8px",
                    margin: "20px 0",
                  }}
                >
                  <h4 style={{ margin: "0 0 10px 0", color: "#52c41a" }}>
                    Trafione słowa ({results.correct.length}):
                  </h4>
                  <p>
                    {results.correct.join(", ") || (
                      <span style={{ color: "#aaa" }}>brak</span>
                    )}
                  </p>

                  <h4 style={{ margin: "20px 0 10px 0", color: "#ff4d4f" }}>
                    Pominięte słowa ({results.missed.length}):
                  </h4>
                  <p>{results.missed.join(", ")}</p>

                  {results.incorrect.length > 0 && (
                    <>
                      <h4 style={{ margin: "20px 0 10px 0", color: "#faad14" }}>
                        Błędnie wpisane / spoza listy (
                        {results.incorrect.length}
                        ):
                      </h4>
                      <p style={{ color: "#777" }}>
                        {results.incorrect.join(", ")}
                      </p>
                    </>
                  )}
                </div>

                <Button onClick={() => setGameState("START")} size="large">
                  Spróbuj ponownie
                </Button>
              </div>
            )}
          </Box>
        </Card>
      </Container>
    </div>
  );
}

const selectStyle = {
  padding: "6px 10px",
  fontSize: "16px",
  borderRadius: "4px",
  border: "1px solid #ccc",
  backgroundColor: "#fff",
};
